<template>
    <div>	
        <div v-for="(TraitForm, index) in TraitForms" :key="'trait'+index" class="traitGridContainer">
            <v-autocomplete
                v-model="TraitForm.traitId"
                v-validate="'required'"
                :items="TraitsOptions"
                item-text="name"
                item-value="id"
                label="Trait"
                :return-object="false"
                :hide-details="true"

                :error-messages="errors.collect('Trait')"
                :data-vv-name="'Trait'"
                required
                @change="UniqueDropdown()"
            />

            <v-text-field
                v-model="TraitForm.minValue"
                v-validate="''"
                label="Min Value"
                type="text"

                :hide-details="true"
                :error-messages="errors.collect('MinValue')"
                :data-vv-name="'MinValue'"
                required
            />

            <v-text-field
                v-model="TraitForm.maxValue"
                v-validate="''"
                label="Max Value"
                type="text"

                :hide-details="true"
                :error-messages="errors.collect('MaxValue')"
                :data-vv-name="'MaxValue'"
                required
            />

            <div class="text-align-center flex-top-auto">
                <div class="groupBtn">
                    <i v-b-tooltip.hover class="fas fa-plus-circle btnStyle addColor" title="Add Trait" @click="addTrait()" /> &nbsp;&nbsp;
                    <i v-b-tooltip.hover class="fas fa-times-circle btnStyle deleteColor" title="Delete Trait" @click="deleteTrait(index)" /> &nbsp;&nbsp;
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["isEmitToParent", "isEmitEditToParent", "editTraitsInfo"],
    data () {
        return {
            msg: "Trait Select Form",

            // v-for TraitForms
            TraitForms: [ 
                { id: 1,  traitId: "", minValue: "", maxValue: "" }
            ],
            nextTraitFormId: 2,

            TraitsOptions: []
        };
    },
    watch: {
        isEmitToParent() {
            var self = this;
            if (this.isEmitToParent == true) {
                self.$emit("emitTraitForms",self.TraitForms);
            }
            else {
                self.TraitForms = [{ id: 1, traitClass: "traitSelect", operatorClass: "operatorSelect", traitId: "", operatorIDSelected: "", minValue: "", maxValue: "" }];
            }
        },
        isEmitEditToParent() {
            var self = this;
            if (this.isEmitEditToParent == true) {
                self.$emit("updateForm",self.TraitForms);
                // self.$emit('update:isEmitEditToParent', false);
            }
        },
        editTraitsInfo() {
            this.bindEditTraitInfoToTraitsForm();
        }
    },
    mounted() {
        // this.select2Fn('Trait/GetAll', 'traitSelect');
        this.getAllTrait();
        // this.bindEditTraitInfoToTraitsForm();
        // this.select2Fn('Operator/GetAll', 'operatorSelect');
    },
    methods: {
        addTrait() {
            this.TraitForms.push({
                id: this.nextTraitFormId++,
                // operatorClass: 'operatorSelect'+this.nextTraitFormId,
                // operatorIDSelected: '',
                // traitClass: 'traitSelect'+this.nextTraitFormId,
                traitId: "",
                minValue: null,
                maxValue: null,
            });
        },
        deleteTrait(index) {
            if (this.TraitForms.length > 1) {
                this.TraitForms.splice(index, 1);
            }
        },
        UniqueDropdown() {
			  var self = this;
			  this.$nextTick(function() {
			    // Disabled false for all the disbaled option
			    self.TraitsOptions.forEach(item => {
			      item.disabled = false;
			    });

			    // Disbaled true for selected option
			    self.TraitForms.forEach(obj => { 
			      self.TraitsOptions.forEach(item => {
			        if (item.id == obj.traitId) {
			          item.disabled = true;
			        }
			      });
			    });
			  });
        },
        getAllTrait() {
            var self = this;
            axios({
                method: "GET",
                url: "Trait/GetAllForDropdown",
            })
                .then(function (response) {
                    self.TraitsOptions = response.data.result;
                });
        },
        bindEditTraitInfoToTraitsForm() {
            this.$nextTick(function() {
                if (this.editTraitsInfo) {
                    var self = this;
                    this.TraitForms = [];
                    this.editTraitsInfo.forEach(function(element) {
                        var tempObj = {};
                        tempObj.id = element.id;
                        tempObj.traitId = element.traitId;
                        tempObj.minValue = element.minValue;
                        tempObj.maxValue = element.maxValue;
                        self.TraitForms.push(tempObj);
                    });
                }
            });
        },
        emitToParent() {
            this.$emit("emitTraitForms", this.TraitForms);
        }
        // select2Fn(urlOpt, classOpt){
        // 	var self = this;
        // 	this.$nextTick(function(){
        // 	  var $ajax = $('.'+classOpt);
        // 	  function formatRepo (repo) {
        // 	    return "<option value='"+repo.id+"'>"+repo.name+"</option>";
        // 	  }

        // 	  function formatRepoSelection (repo) {
        // 	    return repo.name ;
        // 	  }

        // 	  $('.'+classOpt).on("select2:selecting", function(e) { 
        // 	     self.$nextTick(function(){
        // 	     	this.TraitForms.forEach(function(element){
        // 	     		if(element.traitClass == classOpt){
        // 	     			element.traitId = $("."+classOpt).val()
        // 	     		}
        // 	     	})
        // 	     })
        // 	  });

        // 	  $ajax.select2({
        // 	    placeholder: 'Please Select...',
        // 	    minimumInputLength: 0,
        // 	    ajax: {
        // 	      type: "GET",
        // 	      url: urlOpt,
        // 	      dataType: 'json',
        // 	      headers: {
        // 	        'Authorization':'Bearer ' + localStorage.getItem("access_token")
        // 	      },
        // 	      delay: 350,
        // 	      data: function (params) {
        // 	        return {
        // 	          SkipCount: params.SkipCount,
        // 	          MaxResultCount: params.MaxResultCount,
        // 	          Filter: params.term,
        // 	        };
        // 	      },
        // 	      processResults: function (data, params) {
        // 	        console.log(params);
        // 	        params.page = params.page || 1;
        // 	        params.SkipCount = params.page * 10;
        // 	        params.MaxResultCount = 10;
        // 	        params.Filter = params.term;

        // 	        return {
        // 	          results: data.result.items,
        // 	          pagination: {
        // 	            more: (params.page * 10) < data.result.totalCount
        // 	          }
        // 	        };
        // 	      },
        // 	        cache: true
        // 	      },
        // 	      escapeMarkup: function (markup) { return markup; },
        // 	      templateResult: formatRepo,
        // 	      templateSelection: formatRepoSelection,
        // 	    });
        // 	})
        // }
    }
};
</script>
<style scoped>
.flexRatio-1{
	flex: 1;
}
.flexRatio-2{
	flex: 2;
}
.formInlineText{
	margin: 0 1rem;
}
.addColor{
	color: #2962FF;
}
.deleteColor{
	color: #616161;
}
.traitGridContainer{
	display: grid;
	grid-template-columns: 6fr 2fr 2fr 2fr;
	grid-gap: 16px;
}
</style>


// WEBPACK FOOTER //
// src/smallComponents/TraitSelectForm.vue